import moment from 'moment';
import { DateFormat } from '@common/types';

export const dateToString = (date?: number, dateFormat: DateFormat = DateFormat.DDMMYYYYPeriod) =>
  date ? moment(date * 1000).format(dateFormat) : '';
